type Config = Readonly<{
  gonfalon: { host: string };
}>;

const CONFIGS: Record<string, Config> = {
  production: { gonfalon: { host: 'https://app.launchdarkly.com' } },
  staging: { gonfalon: { host: 'https://app-stg.launchdarkly.com' } },
  development: { gonfalon: { host: 'http://localhost:3000' } },
};

const mode = process.env.DOUBLEHELIX_MODE ?? 'development';
const config: Config = CONFIGS[mode] ?? CONFIGS.development;

export default config;
